import { useState, useEffect } from "react";
import { InputField } from "components/InputField/Input";
import { CommonButton } from "components/Buttons/Buttons";
import { BiMinus, BiPlus } from "react-icons/bi";
import useItemDropdown from "./useItemDropdown";
import { dropdownFunction } from "utilities/dropdownFunction";
import { toast } from "react-toastify";
import { useDispatch } from 'react-redux';
import { nullifyStockByBarcodeValue } from '../../../slices/inventory/product.slice'

const useProductDataTable = (formik, setDeleteProductID, setShowDeleteProductModal) => {
    const dispatch = useDispatch();
    const [ index, setIndex ] = useState(null)
    const { setBarcode, productDropdown, setProductDropdown, stockList, stockByBarcode} = useItemDropdown();

    const addProductOnChange = async (e, i, fieldName) => {
        if(fieldName === 'barcode'){
            if(e?.target?.value.length === 13){
                setBarcode(e?.target?.value)
                setIndex(i)
            }
        }

        // console.log("formik.values.sale_items after: ", formik.values.sale_items[i])
        // console.log("item.saleable_quantity after", formik.values.sale_items[i]?.item.saleable_quantity)

        formik.setFieldValue(`sale_items[${i}].${fieldName}`, e?.value || e?.target?.value);

        if(e?.value){
            if(formik.values.sale_items[i]?.item.saleable_quantity > 0){
                if (e?.value > formik.values.sale_items[i]?.item.saleable_quantity){
                    toast.warning("Sale quantity must be less than remaining quantity.(বিক্রয় পরিমাণ অবশিষ্ট পরিমাণ থেকে কম হতে হবে|)")
                    formik.setFieldValue(`sale_items[${i}].${fieldName}`, 1);
                }else{
                    formik.setFieldValue(`sale_items[${i}].${fieldName}`, e?.value || e?.target?.value);
                }
            }
        }
    };

    useEffect(() => {
        if(stockByBarcode){
            setBarcode(null) // This will solve same item scanning row hang issue
            console.log("stockByBarcode: ", stockByBarcode, stockByBarcode['saleable_quantity'])

            if(stockByBarcode['saleable_quantity'] === 0){
                toast.warning("Item quantity not available.")
                // formik.setFieldValue(`sale_items[${index}].${'sale_quantity'}`, 0);
            }else{
                formik.setFieldValue(`sale_items[${index}].${'item'}`, stockByBarcode);
                formik.setFieldValue(`sale_items[${index}].${'sale_quantity'}`, 1);
                const joinData = formik.values.sale_items.concat({
                    id: index + 1,
                    item: "",
                    saleable_quantity: 0,
                    saleable_rate: 0.0,
                    sale_quantity: 0,
                    total_price_per_item: 0.0,
                });
                formik.setFieldValue(`sale_items[${index + 1}].${'item'}`, joinData)
            }
        }
        dispatch(nullifyStockByBarcodeValue()); // nulling the last scanning data from state
    }, [stockByBarcode]);


    const modalTableColumns = [
        {
            field: "barcode",
            header: "Barcode",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField
                        id="barcode"
                        name="barcode"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "barcode")}
                        value={formik.values.sale_items[event.rowIndex]?.barcode}
                        type="autoFocus"
                        label="Barcode"
                        width="full"
                        autoCompleteFieldName="name"
                        autoFocus={true}
                        // required={true}
                        disabled={ formik.values.sale_items[event.rowIndex]?.barcode?.length === 13 ? true : false }
                        errors={formik.errors.sale_items?.[event.rowIndex]?.item?.id}
                    />
                </div>
            ),
        },
        {
            field: "item",
            header: "Item",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField
                        id="item"
                        name="item"
                        autoFilteredValue={productDropdown}
                        autoCompleteMethod={(event) => dropdownFunction(event, setProductDropdown, stockList)}
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "item")}
                        value={formik.values.sale_items[event.rowIndex]?.item}
                        type="select"
                        label="Select Item"
                        width="full"
                        autoCompleteFieldName="name"
                        // required={true}
                        errors={formik.errors.sale_items?.[event.rowIndex]?.item?.id}
                    />
                </div>
            ),
        },
        {
            field: "unit",
            header: "Unit",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="unit"
                        name="unit"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "unit")}
                        value={formik.values.sale_items[event.rowIndex]?.item?.uom}
                        type="text"
                        width="full"
                        autoCompleteFieldName="unit"
                        disabled
                        messagePosition='bottom'
                        errors={formik.errors.sale_items?.[event.rowIndex]?.item?.uom}
                    />
                </div>
            ),
        },
        {
            field: "remain_quantity",
            header: "Remain Quantity",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="remain_quantity"
                        name="remain_quantity"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "remain_quantity")}
                        value={formik.values.sale_items[event.rowIndex]?.item?.saleable_quantity}
                        type="text"
                        width="full"
                        autoCompleteFieldName="remain_quantity"
                        required={false}
                        disabled
                        errors={formik.errors.sale_items?.[event.rowIndex]?.item?.saleable_quantity}
                    />
                </div>
            ),
        },
        {
            field: "rate",
            header: "Rate",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="rate"
                        name="rate"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "rate")}
                        value={formik.values.sale_items[event.rowIndex]?.item?.saleable_rate}
                        type="numbers"
                        width="full"
                        autoCompleteFieldName="rate"
                        required={false}
                        disabled
                        // errors={formik.values.sale_items[event.rowIndex]?.item?.rate}
                    />
                </div>
            ),
        },
        {
            field: "sale_quantity",
            header: "Sale Quantity",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="sale_quantity"
                        name="sale_quantity"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "sale_quantity")}
                        value={formik.values.sale_items[event.rowIndex]?.sale_quantity}
                        type="numbers"
                        width="full"
                        autoCompleteFieldName="sale_quantity"
                        required={false}
                        messagePosition = 'toast'
                        disabled={formik.values.sale_items[event.rowIndex]?.item?.saleable_quantity === 0 ? true : false}
                        errors={formik.errors.sale_items?.[event.rowIndex]?.sale_quantity}
                    />
                </div>
            ),
        },
        {
            field: "total_price_per_item",
            header: "Total price",
            sortableBody: (value, event) => (
                <div className="w-25" style={{"textAlign": "center"}}>
                    <span style={{"color": "#203225"}}>
                        {((parseInt(formik.values.sale_items[event.rowIndex]?.sale_quantity ) * parseFloat(formik.values.sale_items[event.rowIndex]?.item?.saleable_rate)) || 0).toFixed(3)}
                    </span>
                </div>
            ),
        },
    ]

    const deleteProductItems = (rowData) => {
        const {id, requisition} = rowData;
        setDeleteProductID({id, requisition})
        setShowDeleteProductModal(true)
    }

    const modalTableActionButton = (rowData, {rowIndex}) => {
        const handleOnFieldIncrement = () => {
            const joinData = formik.values.sale_items.concat({
                id: rowIndex + 1,
                item: "",
                saleable_quantity: 0,
                saleable_rate: 0.0,
                sale_quantity: 0,
                total_price_per_item: 0.0 ,
            });

            formik.setFieldValue("sale_items", joinData)
            // console.log(formik.values.sale_items)
        };

        const handleOnFieldDecrement = (i) => {
            if(rowData.id > 0){
                return deleteProductItems(rowData)
            }
            const removeData = [...formik.values.sale_items];
            removeData.splice(rowIndex, 1);
            formik.setFieldValue("sale_items", removeData);
            // console.log(formik.values.sale_items)
        };

        return (
            <>
                <div className="flex items-center justify-center">
                    {
                        formik.values.sale_items.length - 1 === rowIndex ? (
                            <>
                                <CommonButton 
                                    icon={<BiPlus className="text-green-700 text-2xl" />}
                                    className="p-button-rounded p-mr-2 action-button-green"
                                    title=""
                                    type="button"
                                    onClick={handleOnFieldIncrement}
                                />
                                {formik.values.sale_items.length !== 1 && 
                                <CommonButton 
                                    icon={<BiMinus className="text-red-700 text-2xl" />} 
                                    className="p-button-rounded p-mr-2 action-button-red" 
                                    title="" 
                                    type="button" 
                                    onClick={handleOnFieldDecrement} 
                                />}
                            </>
                        ) : 
                        (
                            <>
                                <CommonButton 
                                    icon={<BiMinus className="text-red-700 text-2xl" />} 
                                    className="p-button-rounded p-mr-2 action-button-red" 
                                    title="" 
                                    type="button" 
                                    onClick={handleOnFieldDecrement} 
                                />
                            </>
                        )
                    }
                </div>
            </>
        )
    }

    return {
        modalTableColumns,
        modalTableActionButton,
    }
}

export default useProductDataTable